import React from 'react';
import {render} from 'react-dom';
import MyPage from './src/MyPage';

render(
  <MyPage/>,
  document.getElementById('app')
);
